module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day01_04_stay-f6e8b1d15343d0a34e63036263493864.jpg";